<!-- 联系我们 -->
<template>
    <div>
      <sub-banner id="id_about">
        <img src="../../assets/images/concat/concat_header.png"/>
      </sub-banner>
      
      <!--联系我们 start--->
      <div class="concat_tip">
          <div class="product_contents">
              <div class="product_line_left"></div>
              <div class="product_title">{{$t('NavabarText.navbar_contact')}}</div>
              <div class="product_line_right"></div>
          </div>
          <div class="concat_contents">
            <div class="concat_abstract">
              {{$t('NavabarText.contact_us_desc')}}
            </div>
            <div class="concat_info">
              <div class="concat_info_item">
                <div class="icon_div">
                  <span class="icon iconfont icon-gongsi icon_class"></span>
                </div>
                <div class="item_tip">{{$t('footText.company')}}</div>
                <div class="item_name">{{$t('footText.companys')}}</div>
              </div>
              <div class="concat_info_item">
                <div class="icon_div">
                  <span class="icon iconfont icon-a-24gf-telephone2 icon_class"></span>
                </div>
                <div class="item_tip">{{$t('footText.phone')}}</div>
                <div class="item_name">020-37247681</div>
              </div>
              <div class="concat_info_item">
                <div class="icon_div">
                  <span class="icon iconfont icon-youxiang1 icon_class"></span>
                </div>
                <div class="item_tip">{{$t('footText.email')}}</div>
                <div class="item_name">gzsd403@163.com</div>
              </div>
              <div class="concat_info_item">
                <div class="icon_div">
                  <span class="icon iconfont icon-a-Geotagplace icon_class"></span>
                </div>
                <div class="item_tip">{{$t('footText.address_s')}}</div>
                <div class="item_name">{{$t('footText.address')}}</div>
              </div>
            </div>
          </div>
      </div>
      <!--联系我们 end--->

      <div class="concat_navigation">
        <div class="navigation_content">
          <div class="map_address">
            <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true">
               <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
               <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
               <!-- <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :isOpen="true"></bm-overview-map> -->
               <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
               <!-- <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE" title="广州市熵达贸易有限公司">
                </bm-marker> -->
                 <bm-marker :position="center" title="广州市熵达贸易有限公司">
　　　　　　　　　　<!-- 信息窗体组件 -->
                  <bm-info-window title="广州市熵达贸易有限公司" :position="center" :show="true">
                  
                    <p>联系人：陈小姐</p>
                    <p>联系热线：020-37247681</p>
                  </bm-info-window>
                </bm-marker>
                <bm-copyright
                  anchor="BMAP_ANCHOR_TOP_RIGHT"
                  :copyright="[{id: 1, content: '广州市熵达贸易有限公司 ', bounds: {ne: {lng: 113.340491, lat:  23.183773}, sw:{lng: 0, lat: 0}}}]">
                </bm-copyright>
            </baidu-map>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import SubBanner from "@/components/sub-banner";
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner,BaiduMap},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-联系我们',
      metaName:'广州市熵达贸易有限公司-联系我们',
      metaContent:'广州市熵达贸易有限公司-联系我们',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司' ,   
      active_type:'shiaide',
      center: {lng: 0, lat: 0},
      zoom: 19
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
     learMore(){
       
       this.$router.push({
        path: '/cases'
      })
     },
     productTypeClick(val){
         this.active_type=val
     },
     handler ({BMap, map}) {
       //参考 https://dafrok.github.io/vue-baidu-map/#/zh/control/navigation
        console.log(BMap, map)
        this.center.lng = 113.340491
        this.center.lat = 23.183773
        this.zoom = 17  //一共有1-19个等级
      }
  },
  created () {

  },
  mounted () {
  },
}
</script>
<style lang='scss' scoped>

 @import '../../assets/css/animation.css';
.concat_tip{
    width:100%;
    background-color: #fff;
    padding-bottom:134px;
    

}
.product_contents{
        width:70%;
        margin:auto;
        padding-top:115px;
        padding-bottom:52px;
        display: flex;
        align-items: center;
        justify-content: center;
}
.product_line_left{
    width: 210px;
    // height: 0.5px;
    background-color: #2e2d32;
    border: solid 1px #4f7cbd;
    margin-right:28px;
}
.product_title{
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #4f7cbd;
}
.product_line_right{
    width: 210px;
    // height: 1px;
    background-color: #2e2d32;
    border: solid 1px #4f7cbd;
    margin-left:28px;
}


.more_s{
    width: 100%;
    text-align: center;
    .more_c{
        display: flex;
        justify-content: center;
        cursor: pointer;
        .more_btn{
            width: 147px;
            height: 49px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 25px;
            border: solid 2px #4f7cbd;
            color:#2750a2;
            font-size:20px;
            letter-spacing: 2px;
        }
        .more_btn:hover{
            background-color: #4f7cbd !important;
            color:#ffffff !important;
        }
    }
}

.concat_tip{
  width:100%;
  background-color: #fff;
  .concat_contents{
    width:70%;
    margin:auto;
    .concat_abstract{
      text-align: center;
      margin-top:48px;
      font-size: 18px;
      color: #333333;
    }
    .concat_info{
      margin-top:100px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .concat_info_item{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 230px;
        margin-bottom:20px;
        .icon_div{
          width: 82px;
        	height: 82px;
          border: solid 2px #999999;
          border-radius: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          
          .icon_class{
            font-weight: bold;
            font-size: 40px;
            color: #000;
          }
        }
        .item_tip{
          margin-top: 38px;
          color: #333333;
          font-weight: bold;
          font-size: 20px;
        }
        .item_name{
          margin-top:13px;
          font-size: 15px;
          color: #333333;
          max-width: 250px;
        }
      }
    }
  }
}
          
.concat_navigation{
  width: 100%;
  background-color: #ffffff;
  .navigation_content{
    width:70%;
    margin:auto;
    
    .map_address{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 500px;
      .bm-view{
         width:100%;
         height: 500px;
      }
      margin-bottom:120px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/concat/index.vue